export default __webpack_public_path__ + "static/media/defaultFileIcon.e5a35100.svg";